import { render, staticRenderFns } from "./ResultCoursesStudents.vue?vue&type=template&id=ed8dbfda&scoped=true&"
import script from "./ResultCoursesStudents.vue?vue&type=script&lang=ts&"
export * from "./ResultCoursesStudents.vue?vue&type=script&lang=ts&"
import style0 from "./ResultCoursesStudents.vue?vue&type=style&index=0&id=ed8dbfda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed8dbfda",
  null
  
)

export default component.exports